import {
  FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING,
  FRONTEND_STATE_SELECT_LOCATION_START,
  FRONTEND_STATE_SELECT_LOCATION_STOP,
} from './selectLocation.actionTypes';
import type {
  SelectLocationConfiguration, SelectLocationState,
} from './selectLocation.state';

export const startSelectLocationTool = (
  configuration: SelectLocationConfiguration,
  extras?: SelectLocationState['extras'],
) => ({
  type: FRONTEND_STATE_SELECT_LOCATION_START,
  payload: {
    configuration,
    extras,
  },
}) as const;

export const stopSelectLocationTool = () => ({
  type: FRONTEND_STATE_SELECT_LOCATION_STOP,
}) as const;

export const setSelectLocationAddressIsLoading = (isLoading: boolean) => ({
  type: FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING,
  payload: {
    isLoading,
  },
}) as const;
